import React, { useEffect, useState } from 'react';
import bot from '../images/happy.png';
import you from '../images/boy.png';
import image1view1 from '../images/Building1.jpg';
import image1view2 from '../images/Building 1 view.png';
import image2view1 from '../images/Building2.jpg';
import image2view2 from '../images/Building 2 view.png';
import image3view1 from '../images/Tower2.jpg';
import image3view2 from '../images/Tower 2 view.png';
import image4view1 from '../images/Tower3.jpg';
import image4view2 from '../images/Tower 3 view.png';
import Residential from './Residential';
import Commercial from './Commercial';

const LiveImages = ({ siteId }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);

   const [time] = useState(new Date());
    const [loading, setLoading] = useState(true);
    const [showFrame, setShowFrame] = useState(false);
  
    useEffect(() => {
      setTimeout(() => setLoading(false), 1000);
    }, []);
  
    const handleShowFrame = () => {
      setShowFrame(true);
    }

  useEffect(() => {
    let selectedImages = [];

    switch (siteId) {
      case 1:
        selectedImages = [image1view1, image1view2];
        break;
      case 2:
        selectedImages = [image2view1, image2view2];
        break;
      case 3:
        selectedImages = [image3view1, image3view2];
        break;
      case 4:
        selectedImages = [image4view1, image4view2];
        break;
      default:
        selectedImages = [];
    }

    setImages(selectedImages);
    setCurrentIndex(0); // reset carousel when siteId changes
  }, [siteId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        (prevIndex + 1) % images.length
      );
    }, 3000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [images]);

  if (images.length === 0) {
    return <div>No images available for this site.</div>;
  }

  return (
<>
<div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Live Images</div>
      </div>

      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time">{time.toLocaleTimeString()}</div>
      </div>
      <div  style={{textAlign: 'center'}}>
      <strong>Live Images</strong>
      </div>
    <div className="carousel-container">
      
      <div className="image-container">
        <img
          src={images[currentIndex]}
          alt={`View ${currentIndex + 1}`}
          className="carousel-image"
        />
      </div>
      <div className="carousel-controls">
        <button
          onClick={() =>
            setCurrentIndex(
              currentIndex === 0 ? images.length - 1 : currentIndex - 1
            )
          }
          className="nav-button left"
        >
          &#60;
        </button>
        <button
          onClick={() =>
            setCurrentIndex((currentIndex + 1) % images.length)
          }
          className="nav-button right"
        >
          &#62;
        </button>
      </div>
    </div>


    <div>
      <div className="frame1">
        It's nice to interact with you. How do you want to take it forward?<br></br>
        <div style={{textAlign: 'center'}}>
        <button className='details-button1' style={{ width: '50%',fontSize: '13px' }}  onClick={handleShowFrame}>Return to previous menu</button>
        </div>
      </div>

    </div>

    {showFrame && ( (siteId === 1 || siteId === 2)? (<Residential />) : (<Commercial />))}

    
    </>
  );
};

export default LiveImages;
